// React Query keys for Sales & payouts (under ['shop', id] so shop-wide invalidation reaches them).
export const salesKeys = {
  sales: (shopId: string, from: string, to: string) => ['shop', shopId, 'sales', from, to] as const,
};
